import 'reflect-metadata';

import { plainToClass, Transform, TransformFnParams } from 'class-transformer';

// Utility function to get keys of exposed properties as a dictionary
export function getKeysAsDictionary<T>(cls: new () => T): Record<keyof T, keyof T> {
  const instance = plainToClass(cls, {});
  const dictionary: Record<keyof T, keyof T> = {} as Record<keyof T, keyof T>;
  for (const key in instance) {
    if (key) {
      dictionary[key as keyof T] = key as keyof T;
    }
  }
  return dictionary;
}

export function Default(defaultValue: unknown) {
  return Transform((params: TransformFnParams) => {
    if (params.value !== null && params.value !== undefined) {
      return params.value;
    }
    if (typeof defaultValue === 'function') {
      return defaultValue();
    }
    if (Array.isArray(defaultValue)) {
      return [...defaultValue];
    }
    if (typeof defaultValue === 'object') {
      return defaultValue === null ? null : { ...defaultValue };
    }
    return defaultValue;
  });
}
